import { useBannersLoader } from '@/client/loaders/banner'

import NavbarBannerBase from './NavbarBanner.base'
import type { NavbarBannerType } from './types'

const NavbarBanner: React.FC<{
  setShowBanner: (show: boolean) => void
  showingBanner: boolean
}> = ({ setShowBanner, showingBanner }) => {
  const banners: NavbarBannerType[] = useBannersLoader()

  return (
    <NavbarBannerBase
      banners={banners}
      setShowBanner={setShowBanner}
      showingBanner={showingBanner}
    />
  )
}

export default NavbarBanner
